<template>
  <header
    class="fixed top-0 left-0 right-0 z-40 transition-all duration-500 bg-gascon-blue py-2"
  >
    <div class="container mx-auto px-4 flex items-center justify-between">
      <!-- Hamburger menu -->
      <button @click="toggleMenu" class="p-2 hover:opacity-80 hover:cursor-pointer transition-opacity">
        <img
          v-if="!menuOpen"
          src="/images/header_menu.svg"
          alt="Menu"
          class="w-8 h-8"
        />
        <svg v-else class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Logo placeholder (actual logo is animated from HeroSection) -->
      <div class="w-32 h-10"></div>

      <!-- Contact link -->
      <a href="#contact" class="text-white hover:text-gascon-gold transition-colors font-semibold font-raleway">
        Contact
      </a>
    </div>

    <!-- Mobile menu -->
    <transition name="slide">
      <div v-if="menuOpen" class="bg-gascon-blue border-t border-white/10">
        <nav class="container mx-auto px-4 py-6">
          <ul class="space-y-4 font-raleway">
            <li><a href="#hero" @click="closeMenu" class="block text-white hover:text-gascon-gold transition-colors">Home</a></li>
            <li><a href="#news" @click="closeMenu" class="block text-white hover:text-gascon-gold transition-colors">À la une</a></li>
            <li><a href="#contact" @click="closeMenu" class="block text-white hover:text-gascon-gold transition-colors">Contact</a></li>
            <li><a href="#gallery" @click="closeMenu" class="block text-white hover:text-gascon-gold transition-colors">Dans vos cuisines</a></li>
            <li><a href="#team" @click="closeMenu" class="block text-white hover:text-gascon-gold transition-colors">Nos Gars</a></li>
          </ul>
          <a href="#contact" @click="closeMenu" class="mt-6 inline-block bg-gascon-gold text-gascon-blue px-8 py-3 font-semibold hover:opacity-90 hover:cursor-pointer transition-opacity rounded">
            Catalogue
          </a>
        </nav>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      menuOpen: false,
      scrolled: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    },
    handleScroll() {
      // Header appears after scrolling past the hero logo area
      this.scrolled = window.scrollY > 300
    }
  }
}
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.slide-enter-to,
.slide-leave-from {
  max-height: 400px;
  opacity: 1;
}
</style>
